<template>
    <div class="home-page">
        <!-- PC 顶部导航：新增:class绑定固定样式 -->
        <div class="pc-header" v-show="isPC" :class="{ 'fixed-header': isFixed }">
            <div class="logo">
                <img src="@/assets/logo.png" alt="湖北水发" class="logo-img" />
            </div>
            <div class="pc-tabs">
                <span class="pc-tab" :class="{ active: activeTab === 'notice' }"
                    @click="activeTab = 'notice'">招聘公告</span>
                <!-- <span class="pc-tab" :class="{ active: activeTab === 'intro' }" @click="activeTab = 'intro'">子公司简介</span> -->
                <span class="pc-tab" :class="{ active: activeTab === 'job' }" @click="activeTab = 'job'">招聘岗位</span>
                <span class="pc-tab" @click="openLink">集团官网</span>
            </div>
        </div>

        <!-- PC 端 Banner -->
        <div class="banner-pc" v-show="isPC">
            <img src="@/assets/banner-pc.png" alt="PC端banner" class="banner-img" />
        </div>

        <!-- 移动端 Banner -->
        <div class="banner-mobile" v-show="!isPC">
            <img src="@/assets/banner-mobile.png" alt="移动端banner" class="banner-img" />
        </div>

        <!-- 移动端 Tabs -->
        <div class="mobile-tabs-container" v-show="!isPC">
            <div class="tab-bar">
                <div class="tab-item" :class="{ active: activeTab === 'notice' }" @click="activeTab = 'notice'">
                    招聘公告
                </div>
                <!-- <div class="tab-item" :class="{ active: activeTab === 'intro' }" @click="activeTab = 'intro'">
                    子公司简介
                </div> -->
                <div class="tab-item" :class="{ active: activeTab === 'job' }" @click="activeTab = 'job'">
                    招聘岗位
                </div>
                <div class="tab-item" @click="openLink">集团官网</div>
            </div>

            <div class="tab-content">
                <TabNotice v-if="activeTab === 'notice'" />
                <TabIntro v-if="activeTab === 'intro'" />
                <TabJob v-if="activeTab === 'job'" />
            </div>
        </div>

        <!-- PC 内容 -->
        <div class="pc-content" v-show="isPC">
            <TabNotice v-if="activeTab === 'notice'" />
            <TabIntro v-if="activeTab === 'intro'" />
            <TabJob v-if="activeTab === 'job'" />
        </div>

        <TabFooter />
    </div>
</template>

<script>
import TabIntro from "./components/TabIntro.vue";
import TabNotice from "./components/TabNotice.vue";
import TabJob from "./components/TabJob.vue";
import TabFooter from "./components/TabFooter.vue";

export default {
    components: {
        TabIntro,
        TabNotice,
        TabJob,
        TabFooter,
    },
    data() {
        return {
            activeTab: "notice",
            isPC: true,
            isFixed: false, // 新增：控制导航是否固定
        };
    },
    mounted() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
        // 新增：监听滚动事件
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
        // 新增：移除滚动监听
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        onResize() {
            this.isPC = window.innerWidth >= 992;
            // 窗口变化时重新计算固定状态
            this.handleScroll();
        },
        openLink() {
            window.open("https://www.cjtouzi.com/", "_blank");
        },
        // 新增：处理滚动逻辑
        handleScroll() {
            // 当滚动距离超过10px时，固定导航（可根据需求调整阈值）
            this.isFixed = window.scrollY > 10;
        },
    },
};
</script>

<style scoped lang="less">
.home-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #fafbfc;
}

/* PC 导航 */
.pc-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 60px;
    height: 80px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 86, 179, 0.05);
    position: relative;
    z-index: 10;
    /* 新增：过渡动画，让固定/取消固定更平滑 */
    transition: all 0.3s ease;

    .logo {
        display: flex;
        align-items: center;

        .logo-img {
            height: 50px;
            width: auto;
        }
    }

    .pc-tabs {
        display: flex;
        gap: 10px;

        .pc-tab {
            padding: 10px 22px;
            font-size: 16px;
            border-radius: 50px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                background: #e6f0ff;
                color: #006699;
            }

            &.active {
                background: #006699;
                color: #fff;
            }
        }
    }
}

/* 新增：固定导航的样式 */
.fixed-header {
    position: fixed !important;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999 !important; // 提高层级，避免被遮挡
    box-shadow: 0 2px 15px rgba(0, 86, 179, 0.1) !important; // 增强阴影，突出固定效果
}

/* 新增：修复固定后banner上方空白（可选，根据需求调整） */
.banner-pc {
    /* 导航固定后，banner顶部补位（导航高度80px），避免内容跳动 */
    margin-top: v-bind('isFixed ? "80px" : "0"');
    transition: margin-top 0.3s ease;
}

/* ======================
     PC 端 Banner（不遮挡）
  ======================= */
.banner-pc {
    width: 100%;
    line-height: 0;
}

.banner-pc .banner-img {
    width: 100%;
    height: auto;
    display: block;
}

/* ======================
     移动端 Banner（完整）
  ======================= */
.banner-mobile {
    width: 100%;
    line-height: 0;
}

.banner-mobile .banner-img {
    width: 100%;
    height: auto;
    display: block;
}

/* PC 内容 */
// .pc-content {
//     flex: 1;
//     margin: 0 auto;
// }

/* 移动端 Tabs */
.mobile-tabs-container {
    flex: 1;
    display: flex;
    flex-direction: column;

    .tab-bar {
        display: flex;
        background: #fff;
        position: sticky;
        top: 0;
        z-index: 10;

        .tab-item {
            flex: 1;
            text-align: center;
            padding: 14px 0;
            font-size: 15px;
            color: #666;
            position: relative;
            transition: all 0.3s;

            &.active {
                color: #006699;;
                font-weight: bold;
            }

            &.active::after {
                content: "";
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 32px;
                height: 3px;
                background: #006699;
                border-radius: 3px;
            }
        }
    }

    .tab-content {
        flex: 1;
        background: #fafbfc;
    }
}

/* 响应式 */
@media (min-width: 992px) {
    .mobile-tabs-container,
    .banner-mobile {
        display: none !important;
    }
}

@media (max-width: 991px) {
    .pc-header,
    .pc-content,
    .banner-pc {
        display: none !important;
    }
}
</style>